import { symbolToken } from '@servicetitan/react-ioc';
export const LOG_CONFIG_TOKEN = symbolToken('LOG_CONFIG_TOKEN');
export const defaultLogConfig = {
    endpoint: '/Log/Send',
    storageKey: 'LogStorage',
};
//# sourceMappingURL=log-config.js.map